import $ from 'jquery';
import {
    dispatchUnactionedDocketsEvent,
    handleUnactionedDocketsEvent
} from '../../components/filtered-listing/utils/unactioned-items-event';

const dropDown = () => {
    const dropDownEl = $('.user-utilities');
    const dropListEl = $('.utilities-list');

    if (dropDownEl.length > 0) {
        dropDownEl.click(() => {
            dropListEl.toggleClass('active');
        });
    }
};

const unactionedDockets = () => {
    const button = $('.unactioned-dockets');

    if (button.length > 0) {
        button.click(() => {
            dispatchUnactionedDocketsEvent({ event: 'apply-filters' });
        });

        const unactionedDocketsChange = detail => {
            if (detail.event === 'apply-filters') return;

            if (detail.message) {
                button.html(detail.message);
            }

            if (detail.hide) {
                button.hide();
            } else {
                button.show();
            }
        };

        handleUnactionedDocketsEvent(unactionedDocketsChange);
    }
};

$(() => {
    dropDown();
    unactionedDockets();
});
